import axiosInstance from "../../api/axios";

const ExpenseService = {
    getInhouseExpenses: async () => {
        try {
          const response = await axiosInstance.get("/expenses/inhouse");
          if (!response.data.success) {
            throw new Error('Failed to fetch inhouse expenses');
          }
          return { success: true, data: response.data.data };
        } catch (error) {
          console.error("Failed to fetch inhouse expenses", error);
          return { success: false, error };
        }
      },
  getInhouseCategories: async () => {
    try {
      const response = await axiosInstance.get("/categories/inhouse");
      if (!response.data.success) {
        throw new Error('Failed to fetch inhouse categories');
      }
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error("Failed to fetch inhouse categories", error);
      return { success: false, error };
    }
  },

  getContributorCategories: async () => {
    try {
      const response = await axiosInstance.get("/categories/contributors");
      if (!response.data.success) {
        throw new Error('Failed to fetch contributor categories');
      }
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error("Failed to fetch contributor categories", error);
      return { success: false, error };
    }
  },

  /**
   * ISO codes from `currencies` table via GET /api/currencies.
   * Returns { success, options: [{ code, name }], codes: string[] } for stable UI binding.
   */
  getCurrencies: async () => {
    const response = await axiosInstance.get("/currencies");
    const body = response.data ?? {};

    if (!body.success) {
      throw new Error(body.message || "Failed to fetch currencies");
    }

    const rawData = body.data;
    const rawCodes = body.codes;

    let options = [];

    if (Array.isArray(rawData) && rawData.length > 0) {
      options = rawData
        .map((row) => {
          if (row == null) return null;
          if (typeof row === "string") {
            const code = row.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 3);
            return code.length === 3 ? { code, name: code } : null;
          }
          const code = String(row.code ?? row.CODE ?? "").toUpperCase().replace(/[^A-Z]/g, "").slice(0, 3);
          if (code.length !== 3) return null;
          const name = String(row.name ?? row.NAME ?? row.title ?? code);
          return { code, name };
        })
        .filter(Boolean);
    }

    if (options.length === 0 && Array.isArray(rawCodes) && rawCodes.length > 0) {
      options = rawCodes
        .map((c) => String(c).toUpperCase().replace(/[^A-Z]/g, "").slice(0, 3))
        .filter((c) => c.length === 3)
        .map((code) => ({ code, name: code }));
    }

    const codes = options.map((o) => o.code);

    return {
      success: true,
      options,
      codes,
      raw: body,
    };
  },

  /** Artists with label_red_id for expense payload */
  getArtists: async () => {
    const response = await axiosInstance.get("/artists");
    return response.data;
  },

  getContributorExpenses: async () => {
    try {
      const response = await axiosInstance.get("/expenses/contributors");
      if (!response.data.success) {
        throw new Error("Failed to fetch contributor expenses");
      }
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error("Failed to fetch contributor expenses", error);
      return { success: false, error, data: [] };
    }
  },

  createExpense: async (formData) => {
    try {
      const response = await axiosInstance.post("/expenses", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error('Failed to create expense');
      }

      return { success: true, data: response.data };
    } catch (error) {
      console.error("Failed to create expense", error);
      return { success: false, error };
    }
  },

  updateExpense: async (id, formData) => {
    try {
      const response = await axiosInstance.post(`/expenses/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (!response.data.success) {
        throw new Error('Failed to update expense');
      }

      return { success: true, data: response.data };
    } catch (error) {
      console.error("Failed to update expense", error);
      return { success: false, error };
    }
  },
  downloadExpenseFile: async (id) => {
    try {
      const response = await axiosInstance.get(`/expenses/${id}/download`, {
        responseType: 'blob',
      });

      if (!response.status === 200) {
        throw new Error('Failed to download expense');
      }

      return new Blob([response.data], { type: response.headers['content-type'] });
    } catch (error) {
      console.error("Failed to download expense", error);
      throw error;
    }
  },
};

export default ExpenseService;